import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import { Filter, Main } from 'Containers';
import { LoadingPage, TitledCard } from 'Components/';
import SelectSitesTable from 'Common/SelectSitesTable';
import { ReportGeneration } from 'Common/ObjectHelper';
import { createToast, toastError, toastType } from 'Common/ToastHelper';
import { UnappliedStudentsReportForm } from './components/UnappliedStudentsReportForm';
import { UNAPPLIED_STUDENTS_REPORT_FORM_NAME } from 'Common/FormEnum';
import { UnappliedStudentsReportFieldEnum as Fields } from 'Common/FieldEnum';
import { getControlInfo } from 'State/controlInfo/actions';
import {
  getUnappliedStudentsReport,
  clearErrors,
  clearReport,
  setSelectedSites,
  getGrades,
} from './state/report/actions';

class UnappliedStudentsReportContainer extends Component {
  handleSubmit = (formValues) => {
    if (this.props.selectedSites && this.props.selectedSites.length === 0) {
      toastError('You must select at least one site');
      return;
    }
    if (
      !(formValues.ShowFree || formValues.ShowReduced || formValues.ShowPaid)
    ) {
      toastError('Free, Paid, or Reduced must be selected.');
      return;
    }
    const values = { ...formValues, selectedSites: this.props.selectedSites };
    this.props.getUnappliedStudentsReport(values);
  };

  onSiteChange = (selectedSites) => {
    this.props.setSelectedSites(selectedSites);
  };

  getMainProps = () => {
    const { loading } = this.props;
    return {
      toolbox: {
        formName: UNAPPLIED_STUDENTS_REPORT_FORM_NAME,
        saveButtonProps: {
          content: 'View',
          loading: loading,
          disabled: loading,
        },
        shown: true,
      },
    };
  };

  componentDidMount() {
    this.props.getGrades();
    this.props.getControlInfo();
  }

  componentDidUpdate(prevProps) {
    const { report } = this.props;
    if (report && prevProps.report !== report) {
      if (report === 'No Data') {
        createToast(toastType.info, 'Results', 'No data found!', true);
      } else {
        ReportGeneration(report, 'Unapplied Students Report');
      }
      this.props.clearReport();
    }
  }

  render() {
    const { loading, grades, provisionType } = this.props;
    return (
      <Fragment>
        {this.props.loading ? <LoadingPage /> : undefined}
        <Filter title={'Unapplied Students Report'} />
        <Main {...this.getMainProps()}>
          <TitledCard title={'Filters'}>
            <UnappliedStudentsReportForm
              onSubmit={this.handleSubmit}
              loading={loading}
              grades={grades}
              initialValues={{
                [Fields.SortBy]: 0,
                [Fields.Grade]: 'ALL',
                [Fields.ProvisionType]: provisionType,
                [Fields.ShowDirectCertifiedOnly]: false,
                [Fields.HadApplicationFromPriorYear]: false,
              }}
            />
          </TitledCard>
          <TitledCard title={'Sites'}>
            <SelectSitesTable
              onChange={this.onSiteChange}
              fetchAllSites={true}
            />
          </TitledCard>
        </Main>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  const { unappliedStudentsReport } = state.UnappliedStudentsReportState;
  return {
    loading: unappliedStudentsReport.loading,
    report: unappliedStudentsReport.report,
    selectedSites: unappliedStudentsReport.selectedSites,
    grades: unappliedStudentsReport.grades,
    provisionType: state.CommonState.controlInfo.data.ProvisionTypeDefault,
  };
};

export const UnappliedStudents = withRouter(
  connect(mapStateToProps, {
    getUnappliedStudentsReport,
    clearReport,
    setSelectedSites,
    clearErrors,
    getGrades,
    getControlInfo,
  })(UnappliedStudentsReportContainer)
);



// WEBPACK FOOTER //
// ./src/pages/unappliedstudents/UnappliedStudents.js